import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Display } from '../../models/display/dto/display';
import { RefreshDisplays } from '../../models/display/dto/refresh-displays';
import { DisplayAPI } from '../../api/display-api';
import { FileSystemService } from '../../services/file-system.service';
import { FetchOptions } from '../base/fetch-strategy';
import { Repository } from '../base/repository';

/**
 * Data-access layer for a company's displays.
 */
@Injectable()
export class DisplayRepository extends Repository {
  constructor(
    fileSystemService: FileSystemService,
    protected displayAPI: DisplayAPI
  ) {
    super(fileSystemService);
  }

  private readonly companyDisplaysDataKey = 'companyDisplays';

  public refreshDisplays$(payload: RefreshDisplays): Observable<any> {
    return this.displayAPI.refreshDisplays$(payload);
  }

  /**
   * A company's displays, cached per company.
   */
  public getCompanyDisplays$(companyId: number, opts?: FetchOptions): Observable<Display[] | null> {
    const fresh$ = this.displayAPI.getCompanyDisplays$(companyId);
    return this.loadArray$(Display, companyId, null, this.companyDisplaysDataKey, fresh$, opts);
  }
}
